import { render, staticRenderFns } from "./NormalOrder.vue?vue&type=template&id=5a88385d&scoped=true"
import script from "./NormalOrder.vue?vue&type=script&lang=js"
export * from "./NormalOrder.vue?vue&type=script&lang=js"
import style0 from "./NormalOrder.vue?vue&type=style&index=0&id=5a88385d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88385d",
  null
  
)

export default component.exports